<template>
  <div class="register-box">
    <div style="margin-top:30%">
      <div class="registerBox">
        <!-- <div class="quick-box" @click="go('quick')" style="margin-bottom:12%">
        <h3>快捷注册</h3>
        <p>
          快捷注册可成为本会网员注册成功后，可通过登录帐号报名参加本会组织的会议活动及会议签到等。
        </p>
      </div> -->
        <div class="member-box">
          <h3>会员注册</h3>
          <p>
            会员注册需在线填写会员信息，经学会审核通过并缴纳会费后正式成为本会会员，会员可享受本会提供的各种服务，详见<span style="text-decoration:underline"
              @click.stop="goHerf">入会须知</span>。
          </p>
          <div class="btn-box">
            <span @click="go('personRegister',1)" style="border-left:none">个人会员</span>
            <!-- <span @click="go('groupRegister',2)">单位会员</span> -->
          </div>
        </div>
      </div>
      <p class="login-box">
        已有账号，
        <span @click="go('login')">立即登录</span>
      </p>
    </div>
  </div>
</template>

<script>
  import vHead from "../../components/Subhead.vue";
  export default {
    data() {
      return {
        title: "账号注册"
      };
    },
    components: {
      vHead,
    },
    methods: {
      go(type, memberCategory) {
        this.$router.push({ name: type, query: { memberCategory: memberCategory } });
      },
      // goHerf(){
      //     window.open("http://www.forestry.gov.cn/hhxh/268/20150731/985923.html","_blank");
      // },
      goHerf() {
        this.$router.push({ path: '/rule' })
      }
    }
  };
</script>

<style lang="less" scoped>
  .register-box {
    display: flex;
    position: fixed;
    height: 100%;
    overflow-y: auto;
  }

  .registerBox {
    padding: 0 7%;
  }

  h3 {
    margin: 0;
    font-weight: normal;
    font-size: 18px;
    text-align: center;
  }

  p {
    margin: 16px 0 0;
    font-size: 14px;
    line-height: 24px;
  }

  .quick-box {
    padding: 26px;
    color: #fff;
    background: #66666c;
    border-radius: 10px;

    &:active {
      background: #4b4b4e;
    }
  }

  .member-box {
    padding-top: 26px;
    padding-bottom: 0;
    color: #fff;
    background: #1989fa;
    border-radius: 10px;

    p {
      padding: 16px 26px;
      margin-top: 0;

      span {
        font-size: 14px;
      }
    }
  }

  .btn-box {
    display: flex;
    border-top: 1px solid #31a0e4;

    span {
      width: 50%;
      font-size: 14px;
      line-height: 50px;
      text-align: center;

      &:active {
        background: #107abb;
      }
    }

    span {
      border-left: 1px solid #31a0e4;
    }
  }

  .login-box {
    text-align: center;
    margin-top: 15%;
    font-size: 14px;

    span {
      color: #1989fa;
    }
  }
</style>